
`<div class="content-wrapper">
  <section class="content">
      <div class="box">
          <div class="box-body">
              <form [formGroup]="DelegateCreationForm" (ngSubmit)="SaveDelegate()">
                <fieldset>
                    <div class="panel panel-default">
                          <header class="panel-heading"> 
                            <h5 class="panel-title">Delegation</h5>                           
                          </header>
                          <mat-card class="btnCard">
                            <button type="submit" mat-stroked-button>{{btnValue}}</button>                 
                            <button type="button" mat-stroked-button (click)="_commonService.Exit()">Exit</button>
                          </mat-card>
                          <div class="panel-body">
                               <div class="row">                               
                                  <div class="form-group col-md-6">
                                      <label class="required" >Name of Delegate</label>                                      
                                      <p-autoComplete id="auto" formControlName="DelegateName" [suggestions]="delegateList"
                                            (completeMethod)="SearchActiveEmployee($event)" placeholder="Search name"
                                            field="EmployeeName" [forceSelection]="true" [minLength]="3" 
                                            (onSelect)="SetEmployeeDetails($event)"> 
                                        </p-autoComplete>
                                        <mat-error
                                        *ngIf="GetFormControls('DelegateName').invalid && (GetFormControls('DelegateName').dirty || GetFormControls('DelegateName').touched)"
                                        class="ValidationError">
                                        <mat-error *ngIf="GetFormControls('DelegateName').errors.required">
                                          Delegate Name is required.
                                        </mat-error> 
                                    </mat-error>   
                                      </div>
                                      <div class="form-group col-md-6">
                                        <label class="required">Active</label>
                                        <div class="input-group radio-div">
                                            <mat-radio-group formControlName="IsActive" required>
                                                <mat-radio-button  value="true">Yes
                                                </mat-radio-button>
                                                <mat-radio-button value="false">No</mat-radio-button>
                                            </mat-radio-group>
                                            <mat-error
                                            *ngIf="GetFormControls('IsActive').invalid && (GetFormControls('IsActive').dirty || GetFormControls('IsActive').touched)"
                                            class="ValidationError">
                                            <mat-error *ngIf="GetFormControls('IsActive').errors.required">
                                              Status is required.
                                            </mat-error> 
                                        </mat-error>   
                                        </div>
                                    </div>     
                                </div>
                          </div>
                      </div>  
                      </fieldset>
                    </form>
          </div>
      </div>
  </section>
</div>

